import { render, staticRenderFns } from "./HomeScreenDesignConfig.vue?vue&type=template&id=868892d2&"
import script from "./HomeScreenDesignConfig.vue?vue&type=script&lang=js&"
export * from "./HomeScreenDesignConfig.vue?vue&type=script&lang=js&"
import style0 from "./HomeScreenDesignConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports